import React from "react"
import Entity from "../../../entity"

const FormFieldTextarea = ({ domRef, fieldValue, dispatch, info, value, ...props }) => {
    const { language, entity, fieldInfo } = info
    const defaultLanguage = entity._lang
    const [focus, setFocus] = React.useState()
    const handleFocus = React.useCallback(e => {
        setFocus(true)
    }, [])
    const handleBlur = React.useCallback(e => {
        setFocus(false)
    }, [])
    const other = {}
    if (focus) other["is-focus"] = ""
    other["is-empty"] = fieldValue ? "no" : "yes"
    const handleChange = React.useCallback(
        e => {
            //console.log(e.currentTarget.value)
            dispatch({
                type: "change",
                field: info.field,
                label: value.label,
                fieldType: value.fieldType,
                value: e.currentTarget.value,
            })
        },
        [dispatch, info.field, value.fieldType, value.label]
    )
    const label = React.useMemo(
        () => Entity.get(value, "label", { language, defaultLanguage, entityInfo: fieldInfo }),
        [value, language, defaultLanguage, fieldInfo]
    )
    return (
        <div ref={domRef} {...other} {...props}>
            <label htmlFor={info.field}>
                {label}
                {value.mandatory && <sup>*</sup>}
            </label>
            <textarea
                name={info.field}
                type="text"
                value={fieldValue || ""}
                //placeholder={value.label}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </div>
    )
}
export default FormFieldTextarea
